import { useState } from "react";

export const useModal = id => {
  const [isOpen, setIsOpen] = useState(false);

  function show() {
    if (window.wattpad.modals?.[id]) {
      window.wattpad.modals[id].show();
      setIsOpen(true);
    }
  }

  function hide() {
    if (window.wattpad.modals?.[id]) {
      window.wattpad.modals[id].hide();
      setIsOpen(false);
    }
  }

  return {
    isOpen,
    show,
    hide
  };
};
